module.exports = __webpack_public_path__ + "static/ache-a95462ed8c18a388fd1f9f99f4f60aff.png";